import z from "zod";

/**
 * OcorrenciaInspecaoPatrimonioSchema
 */

export const OcorrenciaInspecaoPatrimonioSchema = z.object({

  idInspecaoPatrimonioItens: z.number().nullable().default(null),
  idInspecaoPatrimonio: z.number().nullable().default(null),
  inspecao: z.coerce.number().nullable().default(null),
  dataCriacao: z.coerce.date().nullable().default(null),
  descricao: z.string().nonempty('Este campo deve ser preenchido!'),

  descricaoArquivo1: z.string().nullable().default(null),
  arquivo1: z.instanceof(File).nullable().default(null),
  nomeArquivo1: z.string().nullable().default(null),
  limparArquivo1: z.boolean().optional().default(false),

  descricaoArquivo2: z.string().nullable().default(null),
  arquivo2: z.instanceof(File).nullable().default(null),
  nomeArquivo2: z.string().nullable().default(null),
  limparArquivo2: z.boolean().optional().default(false),

});



/**
 * OcorrenciaInspecaoPatrimonioForm
 */

export type OcorrenciaInspecaoPatrimonioForm = z.infer<typeof OcorrenciaInspecaoPatrimonioSchema>;

